import React, { useState } from 'react';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Button from '@material-ui/core/Button';

import { bulkAddUsersToAlmax } from '../../../services/apiService';
import UserSelection from './UserSelections';
import CohortSelection from './CohortSelection';

function BulkAdd({ dialogOpen, setDialogOpen, dataFetch }) {
  const [users, setUsers] = useState([]);
  const [almaxCohort, setAlmaxCohort] = useState(null);
  const [activeStep, setActiveStep] = React.useState(0);

  const steps = ['Select Users', 'Select Cohort'];

  const bulkAddHandler = async () => {
    await bulkAddUsersToAlmax({
      userIds: Array.from(users.map((item) => item.userId)),
      almaXCohort: {
        almaxCohortId: almaxCohort.id,
        almaxCohortName: almaxCohort.name,
      },
    });
    toggleDialog();
    dataFetch();
  };

  const toggleDialog = () => {
    setDialogOpen(false);
    setActiveStep(0);
    setUsers([]);
    setAlmaxCohort(null);
  };

  return (
    <Dialog
      aria-labelledby='almax-dialog-title'
      open={dialogOpen}
      onClose={toggleDialog}
    >
      <DialogTitle id='almax-dialog-title'>Bulk Add Users To AlmaX</DialogTitle>
      <DialogContent>
        <DialogContentText>Select users to add to AlmaX</DialogContentText>
        <Stepper activeStep={activeStep} alternativeLabel>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
        {activeStep === 0 && (
          <UserSelection value={users} setValue={setUsers} />
        )}
        {activeStep === 1 && (
          <CohortSelection value={almaxCohort} setValue={setAlmaxCohort} />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={toggleDialog} color='primary'>
          Cancel
        </Button>
        {activeStep === 0 ? (
          <Button
            color='primary'
            disabled={users.length === 0}
            onClick={() => setActiveStep(1)}
          >
            Next
          </Button>
        ) : (
          <Button color='primary' onClick={bulkAddHandler}>
            Add
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}

export default BulkAdd;
